import { UnitTransferReasonEnumType } from '__generated__/graphql';

export default function unitTransferReasonToReadable(reason: UnitTransferReasonEnumType): {
  label: string;
  color: string;
} {
  switch (reason) {
    case UnitTransferReasonEnumType.Death:
      return { label: 'Death', color: 'gray' };
    case UnitTransferReasonEnumType.Disability:
      return { label: 'Disability', color: 'gray' };
    case UnitTransferReasonEnumType.EntityRestructuring:
      return { label: 'Entity Restructuring', color: 'sky' };
    case UnitTransferReasonEnumType.FamilyOfficeRestructuring:
      return { label: 'Family Office Restructuring', color: 'sky' };
    case UnitTransferReasonEnumType.SaleOfUnits:
      return { label: 'Sale of Units', color: 'sky' };
    case UnitTransferReasonEnumType.Other:
      return { label: 'Other', color: 'gray' };
    default:
      return { label: reason, color: 'gray' };
  }
}
